import { z } from 'zod';
import { safeParseStored } from '../lib/storage';

const AUTH_STORAGE_KEY = 'auth-storage';

const AuthStorageEventSchema = z.object({
  state: z.object({ user: z.unknown().optional() }).optional(),
  version: z.number().optional(),
});

/**
 * storage 이벤트 핸들러 — 다른 탭에서 로그아웃 감지
 */
export function handleAuthStorageEvent(event: StorageEvent, clearAuth: () => void) {
  if (event.key !== AUTH_STORAGE_KEY) return;

  if (event.newValue === null) {
    clearAuth();
    return;
  }

  const parsed = safeParseStored(event.newValue, AuthStorageEventSchema);
  if (!parsed?.state?.user) {
    clearAuth();
  }
}

/**
 * 앱 초기화 시 호출 — auth storage 이벤트 리스너 등록
 */
export function initAuthCrossTabSync(clearAuth: () => void) {
  const handler = (e: StorageEvent) => handleAuthStorageEvent(e, clearAuth);
  window.addEventListener('storage', handler);
  return () => window.removeEventListener('storage', handler);
}
